// extracted by mini-css-extract-plugin
module.exports = {"emoji":"MilestoneEmoji_emoji__2zQrh"};